import React from 'react';
import './KPIContainer.scss';
import KPISection from './KPISection';

const KPIContainer = ({ kpis }) => {
  return kpis.length > 0 ? (
    <div className="kpi-container" data-testid="kpi-container">
      <h2>KPIs</h2>
      <div className="kpi-subpanel">
        {kpis.map(({ name, indicators }, index) => (
          <KPISection
            name={name}
            index={index}
            indicators={indicators}
            key={`kpi-section-${name}`}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default KPIContainer;
